import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const OBJECT_NOT_FOUND_UPDATE_SIGNATURE_PATTERN =
  /object not found matching id:\d+\b[\s\S]*\bmethodname:update\b[\s\S]*\bparamcount:4\b/;

const hasKnownObjectNotFoundUpdateSignature = (message: unknown): boolean => {
  const normalizedMessage = toNormalizedMessage(message);

  if (!normalizedMessage) {
    return false;
  }

  return OBJECT_NOT_FOUND_UPDATE_SIGNATURE_PATTERN.test(normalizedMessage);
};

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

export const nonErrorObjectNotFoundMatchingIdUnhandledRejectionRule: ClientSentryIgnoreRule =
  {
    id: 'non-error-object-not-found-matching-id-unhandled-rejection',
    references: ['FTR-2836'],
    reason:
      'Known external non-error rejection with no usable seller-ui stack context',
    matches: (context) => {
      if (context.firstExceptionType !== 'UnhandledRejection') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      return (
        hasKnownObjectNotFoundUpdateSignature(context.serializedMessage) ||
        hasKnownObjectNotFoundUpdateSignature(context.originalExceptionMessage)
      );
    },
  };
